import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaRegistro: '1900-01-01',
    fechaEntrega: '1900-01-01',
    fechaCierre: '1900-01-01',
    numero: 0,
    adicionalNumero: 0,
    presupuestoNumero: '',
    clienteId: 0,
    cliente: '',
    accion: '',
    prioridad: '',
    monedaId: 0,
    moneda: '',
    monedaCotizacion: 0,
    usuarios: [],
    ordenesTrabajo: [],
    dirty: false,
    
    cerrado: false,

    /* Ordenes de trabajo + renglon total de ordenes */
    ordenesTrabajoDatos: [],
    ordenesTrabajoDatosTotales: [],

    ordenTrabajoSeleccionada: null,
};

const mutations = {
    updateField,

    'INICIALIZAR_PRESUPUESTO' (state, presupuestoId) {
        state.id = presupuestoId;
        state.fechaRegistro = '1900-01-01',
        state.fechaEntrega = '1900-01-01',
        state.fechaCierre = '1900-01-01',
        state.numero = 0;
        state.adicionalNumero = 0;
        state.presupuestoNumero = '';
        state.clienteId = 0;
        state.cliente = '';
        state.accion = '';
        state.prioridad = '';
        state.monedaId = 0;
        state.moneda = '';
        state.monedaCotizacion = 0;
        state.usuarios = [];
        state.ordenesTrabajo = [];
        state.dirty = false;
        
        state.cerrado = false;

        /* Ordenes de trabajo */
        state.ordenesTrabajoDatos = [];
        state.ordenesTrabajoDatosTotales = [];
    },
    'SET_PRESUPUESTO' (state, presupuesto) {
        state.fechaRegistro = moment(presupuesto.fechaRegistro).format('YYYY-MM-DD');
        state.fechaEntrega = moment(presupuesto.fechaEntrega).format('YYYY-MM-DD');
        state.fechaCierre = moment(presupuesto.fechaCierre).format('YYYY-MM-DD');
        state.numero = presupuesto.numero;
        state.adicionalNumero = presupuesto.adicionalNumero;
        state.presupuestoNumero = presupuesto.presupuestoNumero;
        state.clienteId = presupuesto.clienteId;
        state.cliente = presupuesto.cliente.trim();
        state.accion = presupuesto.accion.trim();
        state.prioridad = presupuesto.prioridad.trim();
        state.monedaId = presupuesto.monedaId;
        state.moneda = presupuesto.moneda.trim();
        state.monedaCotizacion = parseFloat(presupuesto.monedaCotizacion);
        state.usuarios = presupuesto.usuarios;
        state.dirty = false;

        if (moment(presupuesto.fechaCierre).format('YYYY-MM-DD') == '1900-01-01') {
            state.cerrado = false;
        } else {
            state.cerrado = true;
        }

        state.ordenesTrabajo = [];
        presupuesto.ordenesTrabajos.forEach(orden => {
            state.ordenesTrabajo.push({
                id: orden.id,
                rubroTrabajo: orden.rubroTrabajo,
                titulo: orden.titulo.trim(),
                descripcion: orden.descripcion.trim(),
                descripcionProduccion: orden.descripcionProduccion.trim(),
                cantidad: parseFloat(orden.cantidad),
                monedaId: parseInt(orden.monedaId),
                moneda: orden.moneda.trim(),
                monedaAbreviacion: orden.monedaAbreviacion.trim(),
                costoEstimadoTotal: parseFloat(orden.costoEstimadoTotal),
                costoProveedor: parseFloat(orden.costoProveedor),
                costoReal: parseFloat(orden.costoReal),
                certificado: (/true/i).test(orden.certificado),
                tieneImagenes: (/true/i).test(orden.tieneImagenes),
                rowVersion: orden.rowVersion,
                dirty: false,

                subtrabajos: orden.subtrabajos
            });
        });

        setOrdenesTrabajosDatos (state);
    },
    'SELECT_ORDEN' (state, orden) {
        state.ordenTrabajoSeleccionada = orden;
    },
    'UPDATE_ORDEN' (state, params) {
        let orden = state.ordenesTrabajo.find(orden => orden.id == params.ordenTrabajoId);
        if (orden) {
            orden.costoProveedor = params.costoProveedor;

            setOrdenesTrabajosDatos (state);
        }
    },
    'UPDATE_COSTO_ORDEN' (state, params) {
        let orden = state.ordenesTrabajo.find(orden => orden.id == params.ordenTrabajo);
        if (orden) {
            orden.costoEstimadoTotal = params.costoEstimadoTotal;
            state.dirty = true;

            setOrdenesTrabajosDatos (state);
        }
    },
    'RESET_DIRTY' (state) {
        state.dirty = false;
    },
};

function setOrdenesTrabajosDatos (state) {
    state.ordenesTrabajoDatos = [];
    state.ordenesTrabajo.forEach(ordenTrabajo => {
        state.ordenesTrabajoDatos.push({
            ordenTrabajo: ordenTrabajo,

            id: ordenTrabajo.id,
            rubroTrabajo: ordenTrabajo.rubroTrabajo,
            titulo: ordenTrabajo.titulo,
            descripcion: ordenTrabajo.descripcionProduccion ? ordenTrabajo.descripcionProduccion : ordenTrabajo.descripcion,
            cantidad: ordenTrabajo.cantidad,
            moneda: ordenTrabajo.monedaAbreviacion.trim(),
            costoEstimadoTotal: ordenTrabajo.costoEstimadoTotal,
            costoSubtrabajos: ordenTrabajo.costoProveedor,
            costoReal: ordenTrabajo.costoReal,
            readOnly: (/true/i).test(ordenTrabajo.certificado) || (/true/i).test(state.cerrado),
            tieneImagenes: (/true/i).test(ordenTrabajo.tieneImagenes),
            _showDetails: Boolean(false),
            dirty: ordenTrabajo.dirty,

            /* Subtrabajos asociados a la OT */
            subtrabajos: ordenTrabajo.subtrabajos
        });
    });

    /* Calculamos los totales (en $) */
    let costoEstimadoTotal = state.ordenesTrabajo
        .reduce((costoTotal, ordenTrabajo) => {
            let costoEstimado = parseFloat(ordenTrabajo.costoEstimadoTotal);

            if (ordenTrabajo.monedaId == 102) {
                costoEstimado = parseFloat(ordenTrabajo.costoEstimadoTotal) * state.monedaCotizacion;
            }

            return costoTotal + costoEstimado;
        }, 0);

    let costoReal = state.ordenesTrabajo
        .reduce((costoReal, ordenTrabajo) => costoReal + parseFloat(ordenTrabajo.costoReal), 0);

    let costoSubtrabajos = state.ordenesTrabajo
        .reduce((costoSubtrabajos, ordenTrabajo) => costoSubtrabajos + parseFloat(ordenTrabajo.costoProveedor), 0);

    state.ordenesTrabajoDatosTotales = [];
    state.ordenesTrabajoDatosTotales.push({
        totales: 'TOTALES',
        costoEstimadoTotal,
        costoSubtrabajos,
        costoReal
    })
}

const getters = {
    getField,

    ordenesDatos(state) {
        return state.ordenesDatos;
    },
    presupuestoInterno (state) {
        return {
            id: state.id,
            fechaRegistro: state.fechaRegistro,
            fechaEntrega: state.fechaEntrega,
            fechaCierre: state.fechaCierre,
            numero: state.numero,
            adicionalNumero: state.adicionalNumero,
            presupuestoNumero: state.presupuestoNumero,
            cliente: state.cliente,
            accion: state.accion,
            prioridad: state.prioridad,
            moneda: state.moneda,
            monedaCotizacion: state.monedaCotizacion,
            usuarios: state.usuarios
        }
    },
    ordenesTrabajoDatos(state) {
        return state.ordenesTrabajoDatos;
    },
};

const actions = {
    inicializar ( { commit }, presupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PRESUPUESTO', presupuestoId);

            let loadPresupuesto = Boolean(false);

            if (presupuestoId) {
                if (presupuestoId != 0) {
                    loadPresupuesto = Boolean(true);
                }
            }

            if (loadPresupuesto) {
                apiAxios.get(`presupuestosinternos/${presupuestoId}/produccion/abm`) 
                    .then(res => {
                        commit('SET_PRESUPUESTO', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            }
        })            
    },
    save ( { commit, state } ) {
        return new Promise((resolve, reject) => {
            let url = `presupuestosinternos/${state.id}/produccion`;

            let ordenesTrabajo = [];
            state.ordenesTrabajo.forEach(ordenTrabajo => {
                ordenesTrabajo.push({
                    id: ordenTrabajo.id,
                    costoEstimadoTotal: ordenTrabajo.costoEstimadoTotal,
                    rowVersion: ordenTrabajo.rowVersion,
                })
            });
            
            let presupuestoInterno = {
                ordenesTrabajos: ordenesTrabajo
            }

            apiAxios.post(url, presupuestoInterno)
                .then(res => {
                    /* Recuperamos los datos actualizados del presupuesto */
                    commit('SET_PRESUPUESTO', res.data);
                   
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)))                    
        })
    },
    selectOrden: ({commit}, orden) => {
        commit('SELECT_ORDEN', orden);
    },
    updateOrden: ( { commit }, params) => {
        commit('UPDATE_ORDEN', params);
    },
    updateCostoOrden: ({commit}, params) => {
        commit('UPDATE_COSTO_ORDEN', params);
    },
    resetDirty: ({commit}) => {
        commit('RESET_DIRTY');
    },

    getDatos ( { commit }, presupuestoId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_PRESUPUESTO', presupuestoId);

            apiAxios.get(`presupuestosinternos/${presupuestoId}/produccion`) 
                .then(res => {
                    commit('SET_PRESUPUESTO', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}